import { ChevronDown } from 'lucide-react';
import * as React from 'react';
import { BreadcrumbWrapper } from './breadcrumb-wrapper';
import { KlareoIcon } from './klareo-icon';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface TenantOnlyStateProps {
  interactive?: boolean;
  tenantName: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function TenantOnlyState({ interactive = true, tenantName }: TenantOnlyStateProps): React.JSX.Element {
  return (
    <BreadcrumbWrapper interactive={interactive}>
      <div className="flex items-center gap-0.5">
        <div className="flex items-center gap-1.5 text-xs md:text-sm font-medium text-foreground">
          <KlareoIcon />
          <span className="truncate max-w-[200px]">{tenantName}</span>
        </div>
        {interactive && (
          <ChevronDown className="size-3 ms-1 text-muted-foreground/40 group-hover/breadcrumb:text-muted-foreground transition-colors" />
        )}
      </div>
    </BreadcrumbWrapper>
  );
}
